/**
 * Master logikk for Work Environment Dashboard
 * Inkluderer nå utvidede beskrivelser basert på offisielle definisjoner.
 */

export const masterMetrics = {
  weScore: 58,
  conflictRisk: 65,
  stressIndex: 78,
  psychSafety: 42,
  orgHealth: 54
};

export const metricDefinitions = {
  weScore: {
    title: "Work Environment Score",
    desc: "Arbeidsmiljøscore viser en samlet vurdering av organisasjonens psykososiale arbeidsmiljø. Scoren beregnes basert på flere faktorer, inkludert ledelse, samarbeid, rolleavklaringer, arbeidsbelastning, konfliktnivå og psykologisk trygghet. En høy score indikerer et sunt og bærekraftig arbeidsmiljø, mens en lav score kan indikere områder hvor organisasjonen bør iverksette tiltak.",
    icon: 'Zap',
    color: '#6366f1'
  },
  conflictRisk: {
    title: "Conflict Risk Index",
    desc: "Konfliktrisikoindeksen viser sannsynligheten for at konflikter oppstår eller utvikler seg negativt i organisasjonen. Indeksen analyserer blant annet kommunikasjon, tillit, samarbeid og hvordan konflikter håndteres i teamene. Høy konfliktrisiko betyr ikke nødvendigvis at det finnes alvorlige konflikter, men kan indikere strukturer eller arbeidsformer som øker sannsynligheten for konflikter.",
    icon: 'AlertTriangle',
    color: '#f97316'
  },
  stressIndex: {
    title: "Stress Index",
    desc: "Stressindeksen måler opplevd arbeidspress og balansen mellom krav og ressurser i arbeidshverdagen. Høye nivåer av stress over tid kan påvirke både trivsel, helse og produktivitet. Indeksen kan hjelpe ledelsen med å identifisere områder hvor arbeidsbelastning eller organisering av arbeidet bør vurderes.",
    icon: 'Wind',
    color: '#f43f5e'
  },
  psychSafety: {
    title: "Psychological Safety Index",
    desc: "Psykologisk trygghet handler om i hvilken grad medarbeidere opplever at det er trygt å si sin mening, stille spørsmål og dele ideer. Høy psykologisk trygghet er ofte forbundet med bedre samarbeid, høyere læring og bedre prestasjoner i team. Lav psykologisk trygghet kan føre til at viktige problemer ikke tas opp og at medarbeidere holder tilbake informasjon eller ideer.",
    icon: 'Shield',
    color: '#10b981'
  },
  orgHealth: {
    title: "Organizational Health Score",
    desc: "Organizational Health Score gir en samlet vurdering av organisasjonens helhetlige funksjon og bærekraft. Scoren kombinerer data om arbeidsmiljø, kultur, ledelse, samarbeid og medarbeiderengasjement. Dette gir et strategisk bilde av organisasjonens styrker og utviklingsområder.",
    icon: 'Activity',
    color: '#06b6d4'
  }
};

export const getAlerts = (metrics) => {
  const alerts = [];
  if (metrics.stressIndex > 70) {
    alerts.push({
      id: 'stress',
      title: 'High Stress Alert',
      desc: 'Kritisk arbeidspress detektert i Utvikling og Kundeservice.',
      severity: 'Critical',
      color: 'rose'
    });
  }
  if (metrics.conflictRisk > 60) {
    alerts.push({
      id: 'conflict',
      title: 'Conflict Risk Alert',
      desc: 'Økende friksjon og kommunikasjonssvikt i Salgsteamet.',
      severity: 'High',
      color: 'orange'
    });
  }
  return alerts;
};

export const masterRecommendations = [
  {
    title: "Gjennomfør Ressurs-vask",
    category: "Stress Management",
    desc: "Reduser antall aktive prosjekter i Utvikling med 15% for å senke stress-score.",
    icon: 'Layers'
  },
  {
    title: "Lederkurs: Vanskelige samtaler",
    category: "Leadership Guidance",
    desc: "Målrettet trening for ledere i Salg for å håndtere relasjonelle gnisninger.",
    icon: 'MessageCircle'
  }
];